<template>
    <div class="page-container">
        <div class="labelLoader" v-show="!parseInt(this.stock.isReady)">
            <div class="cssload-loader">
							<div class="cssload-inner cssload-one"></div>
							<div class="cssload-inner cssload-two"></div>
							<div class="cssload-inner cssload-three"></div>
						</div>
        </div>
        <div class="product-single">
        <div class="previewContainer product-images previewContainerStock ">
         <a href="javascript:void(0)" class="prev">{{this.$store.getters.strings.previewText}}</a>
            <app-previewstock :stock="stock"></app-previewstock>
        </div>
            <div class="product-description option-counter">
                <h1 class="product-name">{{this.stock.product_name}}</h1>
                <div v-html="this.stock.product_description"></div>
                <div class="labelEdit active">
                    <div class="mainContainer">
                        <div class="printOptionsContainer bigContainer product-option">
                            <app-printoptionsstock :stock="stock"></app-printoptionsstock>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
    import Previewstock from './Previewstock';
    import Printoptionsstock from './Printoptions/Printoptionsstock';

    export default {
        props      : ['stock'],
        components : {
            appPreviewstock       : Previewstock,
            appPrintoptionsstock       : Printoptionsstock
        }
    }
 </script>
<style>



// WEBPACK FOOTER //
// src/components/Stock.vue